// Get the current host for cross-device compatibility
const getApiBaseUrl = () => {
  // In production, use relative URLs
  if (process.env.NODE_ENV === 'production') {
    return '/api/v1';
  }
  
  // Ensure window is available (client-side)
  if (typeof window === 'undefined') {
    return 'http://localhost:8080/api/v1'; // Fallback for SSR
  }
  
  // In development, always use dynamic host detection for cross-device compatibility
  // This works whether accessed from localhost, IP address, or any other device
  const host = window.location?.hostname || 'localhost';
  const protocol = window.location?.protocol || 'http:';
  return `${protocol}//${host}:8080/api/v1`;
};

// Get the public API base URL (no auth required)
const getPublicApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return '/api/v1/public';
  }
  
  if (typeof window === 'undefined') {
    return 'http://localhost:8080/api/v1/public';
  }
  
  const host = window.location?.hostname || 'localhost';
  const protocol = window.location?.protocol || 'http:';
  return `${protocol}//${host}:8080/api/v1/public`;
};

const getWebSocketUrl = () => {
  // In production, use relative URLs with HTTP/HTTPS protocol (SockJS requirement)
  if (process.env.NODE_ENV === 'production') {
    const protocol = window?.location?.protocol || 'http:';
    const host = window?.location?.host || 'localhost:3000';
    // WebSocket endpoint should be at /ws, not /api/ws in production
    // In production, nginx/ALB routes /ws to notification service
    return `${protocol}//${host}/ws`;
  }
  
  // Ensure window is available (client-side)
  if (typeof window === 'undefined') {
    return 'http://localhost:8081/ws'; // Fallback for SSR - notification service
  }
  
  // In development, connect directly to notification service on port 8081
  const host = window.location?.hostname || 'localhost';
  const protocol = window.location?.protocol || 'http:';
  return `${protocol}//${host}:8081/ws`;
};

// Static configuration (environment variables and constants)
const config = {
  api: {
    baseUrl: getApiBaseUrl(),
    publicUrl: getPublicApiBaseUrl(), // Public API for unauthenticated requests
    mediaUrl: `${getApiBaseUrl()}/media`
  },
  websocket: {
    url: getWebSocketUrl()
  },
  app: {
    // These can be overridden by ConfigurationService
    name: process.env.REACT_APP_APP_NAME || 'Experience',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development'
  },
  services: {
    stripe: {
      publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY
    },
    analytics: {
      googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID
    },
    firebase: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID
    }
  },
  features: {
    // These can be overridden by ConfigurationService at runtime
    chat: process.env.REACT_APP_ENABLE_CHAT === 'true',
    payments: process.env.REACT_APP_ENABLE_PAYMENTS === 'true',
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true'
  }
};

export default config;